export default __webpack_public_path__ + "static/_49A4081.png";